import { z } from 'zod'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { adminBillingAccountsQueryOptions } from '@/lib/queries/admin'
import {
  AdminBillingDialogs,
  AdminBillingList,
  AdminBillingPrimaryButtons,
  AdminBillingProvider,
} from '@/features/admin'

const adminBillingSearchSchema = z.object({
  billing_account_id: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/admin/billing')({
  validateSearch: adminBillingSearchSchema,
  loader: ({ context }) => {
    context.queryClient.query({
      ...adminBillingAccountsQueryOptions(),
      staleTime: 'static',
    })
  },
  component: AdminBillingPage,
})

function AdminBillingPage() {
  const { data: billingAccounts } = useSuspenseQuery(
    adminBillingAccountsQueryOptions()
  )

  return (
    <AdminBillingProvider>
      <div className='w-full space-y-2'>
        <div className='flex items-center justify-between'>
          <div>
            <h2 className='font-heading text-xl'>Billing Accounts</h2>
            <p className='text-muted-foreground text-sm'>
              Manage billing accounts and credits
            </p>
          </div>
          <AdminBillingPrimaryButtons />
        </div>

        <AdminBillingList data={billingAccounts} />
      </div>

      <AdminBillingDialogs />
    </AdminBillingProvider>
  )
}
